import ActivateCustomerDataView from 'views/UseCases/ActivateCustomerData'

const ActivateCustomerData = () => <ActivateCustomerDataView />

export default ActivateCustomerData
